module.exports = __webpack_public_path__ + "static/media/style.a5f653df.jpg";